import { enumRecordToCheckboxOptions } from '../helpers';

// String enum to match backend JsonStringEnumConverter
export enum ScopeOfPracticeEnum {
  Cna = 'Cna', // Certified Nursing Assistant
  Hha = 'Hha', // Home Health Aide
  Lpn = 'Lpn', // Licensed Practical Nurse
  Lvn = 'Lvn', // Licensed Vocational Nurse
  Ma = 'Ma', // Medical Assistant
  Ot = 'Ot', // Occupational Therapist
  Phlebotomist = 'Phlebotomist', // Phlebotomists
  Pt = 'Pt', // Physical Therapist
  Rn = 'Rn', // Registered Nurse (includes Bachelor and Master of Science in Nursing)
  RtRec = 'RtRec', // Recreational Therapist
  RtResp = 'RtResp', // Respiratory Therapist
  Slp = 'Slp' // Speech-Language Pathologist
}

export const SCOPE_OF_PRACTICE_ENUM_RECORD: Record<
  ScopeOfPracticeEnum,
  string
> = {
  [ScopeOfPracticeEnum.Cna]: 'Certified Nursing Assistant',
  [ScopeOfPracticeEnum.Hha]: 'Home Health Aide',
  [ScopeOfPracticeEnum.Lpn]: 'Licensed Practical Nurse',
  [ScopeOfPracticeEnum.Lvn]: 'Licensed Vocational Nurse',
  [ScopeOfPracticeEnum.Ma]: 'Medical Assistant',
  [ScopeOfPracticeEnum.Ot]: 'Occupational Therapist',
  [ScopeOfPracticeEnum.Phlebotomist]: 'Phlebotomist',
  [ScopeOfPracticeEnum.Pt]: 'Physical Therapist',
  [ScopeOfPracticeEnum.Rn]: 'Registered Nurse',
  [ScopeOfPracticeEnum.RtRec]: 'Recreational Therapist',
  [ScopeOfPracticeEnum.RtResp]: 'Respiratory Therapist',
  [ScopeOfPracticeEnum.Slp]: 'Speech-Language Pathologist'
};

export const SCOPE_OF_PRACTICE_ABBREVIATED_RECORD: Record<
  ScopeOfPracticeEnum,
  string
> = {
  [ScopeOfPracticeEnum.Cna]: 'CNA',
  [ScopeOfPracticeEnum.Hha]: 'HHA',
  [ScopeOfPracticeEnum.Lpn]: 'LPN',
  [ScopeOfPracticeEnum.Lvn]: 'LVN',
  [ScopeOfPracticeEnum.Ma]: 'MA',
  [ScopeOfPracticeEnum.Ot]: 'OT',
  [ScopeOfPracticeEnum.Phlebotomist]: 'Phleb.',
  [ScopeOfPracticeEnum.Pt]: 'PT',
  [ScopeOfPracticeEnum.Rn]: 'RN',
  [ScopeOfPracticeEnum.RtRec]: 'RT (Rec)',
  [ScopeOfPracticeEnum.RtResp]: 'RT (Resp)',
  [ScopeOfPracticeEnum.Slp]: 'SLP'
};

export const SCOPE_OF_PRACTICE_OPTIONS: {
  value: ScopeOfPracticeEnum;
  label: string;
  description?: string;
}[] = enumRecordToCheckboxOptions(SCOPE_OF_PRACTICE_ENUM_RECORD);
